import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Table } from "@tanstack/react-table";
import { readClientsClientsGet } from "@/client-admin";
import { Input } from "@/components/ui/input";
import { SelectClientNameComboBox } from "@/components/admin/UserClientLinkTable/SelectClientNameComboBox";
import { LoadingComponent } from "@/components/LoadingComponent";
import { UserWithClients } from "./columns";
import { DataTableViewOptions } from "./data-table-view-options";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function DataTableToolbar({ table }: DataTableToolbarProps<UserWithClients>) {
  const [selectedClient, setSelectedClient] = useState<number | null>(null);
  const { data, isLoading, isError } = useQuery({
    queryKey: ["clients"],
    queryFn: () => readClientsClientsGet(),
  });

  if (isLoading) return <LoadingComponent />;
  if (isError) return <div>Error fetching clients</div>;

  return (
    <div className="grid grid-cols-1 gap-2">
      <div className="flex flex-col gap-2 sm:flex-row">
        <Input
          placeholder="Filter user email..."
          value={(table.getColumn("email")?.getFilterValue() as string) ?? ""}
          onChange={(event) => table.getColumn("email")?.setFilterValue(event.target.value)}
        />
        <SelectClientNameComboBox
          value={selectedClient}
          onChange={(selectedOption) => {
            setSelectedClient(selectedOption ? selectedOption : null);
            table.getColumn("client_links")?.setFilterValue(selectedOption ? selectedOption : null);
          }}
          data={data}
        />
        <DataTableViewOptions table={table} />
      </div>
    </div>
  );
}
